import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

    body {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        font-family: 'Dosis', sans-serif;
        color: #50252D;
        scroll-behavior: smooth;
    }
`;
